import DataTargets from './DataTargets.vue';
export default DataTargets;
